import { getTemplateTagLabel } from 'src/data/template';
import { defineDefaultEnumValue } from 'src/lib/enum';

/**
 * Sidebar tab types
 * @enum {string}
 * @property {SIDEBAR_TAB_TYPE} DEFAULT - default generation tool
 */
export const SIDEBAR_TAB_TYPE = {
  all: 'all',
  mostPopular: 'most_popular',
  savedTemplates: 'saved_templates',
  templateTag: 'template_tag',
};
defineDefaultEnumValue(SIDEBAR_TAB_TYPE, SIDEBAR_TAB_TYPE.mostPopular);

export const SIDEBAR_TAB_ALL = {
  type: SIDEBAR_TAB_TYPE.all,
  label: 'All',
};
export const SIDEBAR_TAB_MOST_POPULAR = {
  type: SIDEBAR_TAB_TYPE.mostPopular,
  label: 'Most popular',
};
export const SIDEBAR_TAB_SAVED_TEMPLATES = {
  type: SIDEBAR_TAB_TYPE.savedTemplates,
  label: 'Your saved templates',
};

export const createSidebarTemplateTagTab = (templateTag) => ({
  type: SIDEBAR_TAB_TYPE.templateTag,
  templateTag,
  label: getTemplateTagLabel(templateTag),
});
